import { render, staticRenderFns } from "./IndustryList.vue?vue&type=template&id=fd8cfff0&scoped=true&"
import script from "./IndustryList.vue?vue&type=script&lang=js&"
export * from "./IndustryList.vue?vue&type=script&lang=js&"
import style0 from "./IndustryList.vue?vue&type=style&index=0&id=fd8cfff0&scoped=true&lang=css&"
import style1 from "./IndustryList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd8cfff0",
  null
  
)

export default component.exports